<template>
  <div class="stubyclub_info">
    <el-row>
        <el-col :span="24">
            <el-button style="padding: 0; margin: 20px;" type="text" icon="el-icon-back" @click="$router.go(-1)">
                返回
            </el-button>
        </el-col>
    </el-row>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="活动名称" class="is-required inputbox">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="活动头图" class="image_box" >
          <activityCustomUpload :tip="'只能上传jpg/png文件，上传尺寸推荐1200*1500px 大小不超过300kb'" :formName="'head_img_url'" :formValue="form.head_img_url"
          @uploadSuccess="uploadSuccess">
          </activityCustomUpload>
      </el-form-item>
      <el-form-item label="案例背景图" class="image_box" >
          <activityCustomUpload :tip="'只能上传jpg/png文件，上传尺寸推荐1200*1500px 大小不超过300kb'" :formName="'case_bg_img_url'" :formValue="form.case_bg_img_url"
          @uploadSuccess="uploadSuccess">
          </activityCustomUpload>
      </el-form-item>
      <el-form-item label="案例视频" class="inputbox">
        <el-input v-model="form.case_video_url" placeholder="填入OSS地址"></el-input>
      </el-form-item>
      <el-form-item label="活动背景图" class="image_box" >
          <activityCustomUpload :tip="'只能上传jpg/png文件，上传尺寸宽度推荐1200，不限制高度 大小不超过800kb'" :formName="'activity_bg_img_url'" :formValue="form.activity_bg_img_url"
          @uploadSuccess="uploadSuccess">
          </activityCustomUpload>
      </el-form-item>
      <el-form-item label="底部视频" class="inputbox">
        <el-input v-model="form.bottom_video_url" placeholder="填入OSS地址"></el-input>
      </el-form-item>
      <el-form-item label="悬浮按钮图" class="image_box" >
          <activityCustomUpload :tip="'只能上传jpg/png文件，上传尺寸推荐200*200px 大小不超过100kb'" :formName="'floating_btn_img_url'" :formValue="form.floating_btn_img_url"
          @uploadSuccess="uploadSuccess">
          </activityCustomUpload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updateinfo">确定</el-button>
        <el-button @click="clossinfopage">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import { getstudyinfo,updatestudyinfo } from "@/api/yxs"
export default {
    name: "",
    data() {
        return {
          form:{
            id:'',
            title:'',
            head_img_url:'',
            case_bg_img_url:'',
            case_video_url:'',
            activity_bg_img_url:'',
            bottom_video_url:'',
            floating_btn_img_url:'',
          }
        };
    },
    components: {activityCustomUpload,},
    computed: {},
    created(){
      this.form.id = this.$route.query.id;
    },
    mounted() {
      this.getinfoHandel()
    },
    methods: {
      clossinfopage(){
            this.title='',
            this.head_img_url='',
            this.case_bg_img_url='',
            this.case_video_url='',
            this.activity_bg_img_url='',
            this.bottom_video_url='',
            this.floating_btn_img_url='',
            this.$router.go(-1)
      },
      updateinfo(){
        if(this.validateForm(this.form)){
          updatestudyinfo(this.form).then((res)=>{
            if(res.code){
              this.$message.success('保存成功')
              this.$router.go(-1)
            }
          })
        }

      },
      getinfoHandel(){
        getstudyinfo(this.form).then((res)=>{
          if(res.code){
            this.form = res.data
          }
        })
      },
      uploadSuccess(value) {
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();

            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );

            if (isImageFormat) {
                // console.log('是图片格式');
                this.form[value.formName] = value.fileUrl;
            } else {
                this.$message({
                    message: "请上传图片格式文件",
                    type: "error",
                });
                return;
            }
        },
        validateForm(form) {
        // 遍历 form 对象的属性，检查是否为空
        for (let key in form) {
          if (!form[key]) {  // 如果值为空或为 falsy 值 (undefined, null, '', 0, NaN, false)
            console.log(`${key} is empty`);
            if(key == 'title'){
              this.$message.error('请填写活动名称');
              return false;
            }
            /*else if(key == 'head_img_url'){
              this.$message.error('请上传活动头图')
            }else if(key == 'case_bg_img_url'){
              this.$message.error('请上传案例背景图')
            }else if(key == 'case_video_url'){
              this.$message.error('请上传案例视频OSS链接')
            }else if(key == 'bottom_video_url'){
              this.$message.error('请上传底部视频OSS链接')
            }else if(key == 'floating_btn_img_url'){
              this.$message.error('请上传悬浮按钮图')
            }else if(key == 'activity_bg_img_url'){
              this.$message.error('请上传活动背景图')
            }
            return false;*/  // 找到空值时返回 false，表示验证失败
          }
        }
        return true;  // 所有属性都有值时返回 true，表示验证成功
      }
    },
};
</script>

<style >
.stubyclub_info .inputbox .el-input{
    width: 300px;
}
.stubyclub_info .el-form-item__label{
  width: 120px !important;
}
</style>
